<template>
	<section id="contact">

		<!-- <div id="banner" class="animate__animated animate__fadeIn">
        <div class="container-fluid">
            <div class="row">
              <picture>
                <source media="(min-width: 768px)" srcset="../picture/contactus1.jpg">
                <source media="(min-width: 1px)" srcset="../picture/contactus2.jpg">
                <img src="../picture/contactus1.jpg" />
              </picture>
            </div>
        </div>
    </div> -->

		<section id="main">
			<div class="container">
				<div class="col-sm-12 form-wrapper">
					<h2 v-html="$t('form_c.enquiryform')"></h2>
					<span class="notes">*{{ $t('form_c.mandatory') }}</span>
					<p class="mp-4 bor-b"></p>

					<div class="p mt-4" v-html="$t('us_txt')"></div>

					<iframe style="border:0" class="iframe-map mt-4"
						src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d460.9645435495917!2d114.007308!3d22.4396996!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403fa7bf5f3a917%3A0xd6236a94a25479bf!2sKIA%20Hong%20Kong%20-%20Yuen%20Long%20Showroom%20%26%20Service%20Centre!5e0!3m2!1sen!2skr!4v1620959972620!5m2!1sen!2skr"
						frameborder="0" allowfullscreen=""></iframe>

					<form class="mt-5" id="form" ref="forms">
						<input type="hidden" name="source" id="source" value="Contact Us">
						<div class="form-group field-wrapper row">
							<div class="col-sm-5"><label for="name" class="form-label">{{ $t('form_c.name') }}<span
										class="red">*</span></label></div>
							<div class="col-sm-7 textInput">
								<input type="text" class="form-control required" v-validate="'required'" name="userName"
									v-model="formAdd.name">
								<span class="textfield__counter" v-show="errors.has('userName')">{{ errors.first('userName') }}</span>
							</div>
						</div>
						<div class="form-group field-wrapper row">
							<div class="col-sm-5"><label for="phone" class="form-label">{{ $t('form_c.contactphonenumber') }}<span
										class="red">*</span></label></div>
							<div class="col-sm-7 number-relative">
								<em>+852</em>
								<input type="text" class="form-control required phone number" v-validate="'required|numeric'"
									name="mobile" v-model="formAdd.phoneNumber">
								<span class="textfield__counter" v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
							</div>
						</div>
						<div class="form-group field-wrapper row">
							<div class="col-sm-5"><label for="email" class="form-label">{{ $t('form_c.email') }}<span
										class="red">*</span></label></div>
							<div class="col-sm-7">
								<input type="text" class="form-control email required" v-validate="'required|email'" name="emailAdd"
									v-model="formAdd.email">
								<span class="textfield__counter" v-show="errors.has('emailAdd')">{{ errors.first('emailAdd') }}</span>
							</div>
						</div>
						<div class="form-group field-wrapper row">
							<div class="col-sm-5"><label for="enquiry" class="form-label">{{ $t('form_c.enquiry') }}<span
										class="red">*</span></label></div>
							<div class="col-sm-7">
								<select class="form-control" name="enquiry" v-validate="'required'" v-model="formAdd.enquiry">
									<option value="">{{ $t('form_c.enquiryList[0]') }}</option>
									<option value="Test Drive">{{ $t('form_c.enquiryList[1]') }}</option>
									<option value="Trade-In">{{ $t('form_c.enquiryList[2]') }}</option>
									<option value="Car Finance/ Leasing">{{ $t('form_c.enquiryList[3]') }}</option>
									<option value="Others">{{ $t('form_c.enquiryList[4]') }}</option>
								</select>
								<span class="textfield__counter" v-show="errors.has('enquiry')">{{ errors.first('enquiry') }}</span>
							</div>
						</div>
						<div class="form-group field-wrapper row" style="margin-bottom: 0;">
							<div class="col-sm-5"><label for="others" class="form-label">{{ $t('form_c.message') }}</label></div>
							<div class="col-sm-7"><textarea class="form-control" name="others" v-model="formAdd.others"></textarea>
							</div>
						</div>

						<!-- <div class="form-group field-wrapper row"> -->
						<!-- <div class="col-sm-5"><label class="form-label">Security Check</label></div> -->
						<!-- <div class="col-sm-7">
										<div class="g-recaptcha" data-sitekey="6LfMPxsTAAAAABD0DZCkL383G0SJh8LGqTBfMbtk"></div>
										<input type="hidden" class="hiddenRecaptcha" name="hiddenRecaptcha" id="hiddenRecaptcha">
								</div> -->
						<!-- </div> -->
						<!-- <div class="checkbox"> -->
						<!-- <label>
									<input type="checkbox" name="privacy" id="privacy" value="y" class="" checked v-model="formAdd.privacy">
									<label for="privacy" class="check-icon"></label> 
									I would like to receive news and updates from your Company, and I do consent to your Company using my personal data for direct marketing as described in the 
									<router-link to="/privacypolicy" style="color: #337ab7">Personal Data and Privacy Statement</router-link> of your Company.
								</label> -->
						<!-- </div> -->
						<div class="w-100 mb-10"></div>

						<!-- <div id="privacy-fields">
							<div class="row mt-7">
								<div class="col-sm-12 col-xs-12 col-md-10">
									<p class="aui-small" v-html="$t('kamlungmotorslimited')"></p>
								</div>
							</div>
						</div> -->
						<div class="check-text">
							<div class="col-sm-12 col-xs-12 check-p">
								<label class="aui-checkbox aui-js-checkbox" @change="checkboxCl($event)">
									<input class="aui-checkbox__input" type="checkbox" name="privacy" v-validate="'seeyn'"
										:value="formAdd.privacy ? true : false" checked v-model="formAdd.privacy">
									<span class="aui-checkbox__label">
										<strong>{{ $t('Privacy_yn_1') }} <a href="javascript:;" @click="showPopup()"
												style="color: #000; font-weight: 600; text-decoration: underline;">
												{{ locale == 'en' ? 'PrivacyPolicy' : '私隱政策' }}</a> {{ $t('Privacy_yn_2') }}</strong>
									</span>
									<span :class="['aui-checkbox__box', formAdd.privacy == true ? 'is-checked' : '']"><span
											class="aui-checkbox__tick iconfont">&#xe60e;</span></span>

									<span class="textfield__counter ys" v-show="errors.has('privacy')">{{ errors.first('privacy')
									}}</span>
								</label>
							</div>


							<div class="col-sm-12 col-xs-12 check-p">
								<label class="aui-checkbox aui-js-checkbox ml-4" @click="checkboxCl($event)">
									<input class="aui-checkbox__input" type="checkbox" name="warranty"
										:value="formAdd.warranty ? true : false" checked v-model="formAdd.warranty">
									<span class="aui-checkbox__label"><strong v-html="$t('warranty')"></strong></span>
									<span :class="['aui-checkbox__box', formAdd.warranty == true ? 'is-checked' : '']"><span
											class="aui-checkbox__tick iconfont">&#xe60e;</span></span>

									<span class="textfield__counter ys grey">{{ $t('PINNED') }}</span>
								</label>
							</div>
						</div>

						<div class="form-group aui-button-group">
							<!-- <a href="javascript:void(0);" id="submit" class="pull-right">Submit</a> -->
							<van-button id="btn-valuation-submit" :loading="load" native-type="button"
								class="aui-js-response aui-button aui-button-primary btn-loadable" type="primary" @click="onSubmit()">
								<span class="aui-button__text">{{ $t('submit') }}
									<!-- <i class="iconfont">&#xe60e;</i> -->
								</span>
							</van-button>
						</div>

					</form>
				</div>
			</div>
		</section>
		<van-popup class="van-popup1" closeable close-icon="close" v-model="showPrivacyPolicy">
			<PrivacyPolicy v-if="locale == 'zh' ? true : false" />
			<PrivacyPolicyEn v-if="locale == 'en' ? true : false" />
		</van-popup>
		<div hidden>
			Contact Us
		</div>
	</section>
</template>

<script>
import Vue from 'vue'
import { reqAddContactUs } from "../untils/api"
import { Toast, Button, Popup } from 'vant'
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicyCn'
import PrivacyPolicyEn from '../components/PrivacyPolicy/PrivacyPolicyEn'
export default {
	metaInfo: {
		title: 'Contact Us', // set a title
		meta: [{             // set meta
			name: 'keywords',
			content: 'Contact Us'
		},
		{
			name: 'description',
			content: 'Contact Us'
		}]
	},
	name: "ContactUs",
	inject: ['reload'],
	data() {
		return {
			locale: this.$store.state.locale,
			showPrivacyPolicy: false,
			load: false,
			formAdd: {
				name: '',
				phoneNumber: '',
				email: '',
				enquiry: '',
				others: '',
				privacy: false,
				warranty: false
			}
		}
	},
	components: {
		PrivacyPolicy,
		PrivacyPolicyEn
	},
	mounted() {
		PubSub.subscribe('locale', (msg, data) => {
			if (data.locale != '') {
				this.reload()
				this.$validator.locale = this.$store.state.locale
			}
		})
		// 从车辆详情页跳转过来时，默认填入车辆信息
		if (this.$route.query.car) {
			this.formAdd.others = this.$route.query.car
		}
	},
	methods: {
		showPopup() {
			this.showPrivacyPolicy = true
		},

		onSubmit() {
			console.log(this.$validator.validate())
			this.$validator.validate().then(result => {
				if (!result) {
					Toast({ message: this.errors.all()[0], duration: 1500 });  // ui框架的提示弹窗
					return
				} else {
					this.load = true
					if (this.formAdd.privacy == 1 || this.formAdd.privacy == true) {
						let _ = this.formAdd
						let data = {
							name: _.name,
							phoneNumber: '(+852)' + _.phoneNumber,
							email: _.email,
							enquiry: _.enquiry,
							others: _.others,
							agree: _.warranty
						}
						setTimeout(() => {
							reqAddContactUs(data).then(res => {
								if (res.code == 200) {
									this.load = false
									Toast({ type: 'success', duration: 2000 })
									this.reload()
								}
							})
						}, 700)
					} else {
						this.load = false
						Toast({ message: '*This is required.', duration: 2000 });  // ui框架的提示弹窗
					}
					//  this.handleSaveParam();   // 验证通过后请求接口的方法
				}
			})
		},

		checkboxCl(e) {
			// console.log('e', e)
			if (e.type == 'change') {
				if (e.target.checked == true) {
					console.log('this.formAdd.privacy1', this.formAdd.privacy)
					console.log('this.formAdd.warranty1', this.formAdd.warranty)
					e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.add('is-checked')
				} else if (e.target.checked == false) {
					console.log('this.formAdd.privacy2', this.formAdd.privacy)
					console.log('this.formAdd.warranty2', this.formAdd.warranty)
					e.currentTarget.firstElementChild.nextElementSibling.nextElementSibling.classList.remove('is-checked')
				}
			}
		},
	},
};
</script>

<style scoped lang="scss">
	.number-relative {
		position: relative;
		padding-left: 70px;
		em {
			position: absolute;
			top: 6px;
			left: 18px;
			font-size: 16px;
			font-style: normal;
		}
	}

	.red {
		color: #dc3545;
	}
	#contact .google-maps {
			position: relative;
			padding-bottom: 75%;
			height: 0;
			overflow: hidden;
			margin: 40px 0;
	}
	#contact .google-maps iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100% !important;
			height: 100% !important;
	}
	#contact .iframe-map {
		width: 100%;
		height: 600px;
	}

	#contact h4,
	#contact p,
	#contact label {
			// font-size: 11pt;
			font-size: 16px;
	}

	#contact h4 {
			margin: 20px 0 0 0;
			font-weight: bold;
	}

	#contact p {
			margin: 0;
	}
	#contact .form-group {
		margin-bottom: 24px;
	}
	#contact .textInput {
		position: relative;
	}

	/*form-wrapper*/

	.form-wrapper .notes {
			color: #8d8d8d;
			font-style: italic;
	}

	.form-wrapper #form {
			position: relative;
			overflow: hidden;
	}

	.form-wrapper .form-label {
			width: 200px;
			font-weight: normal;
	}

	.form-wrapper #form input[type="text"],
	.form-wrapper #form select,
	.form-wrapper #form textarea {
			border-radius: 0;
	}

	.form-wrapper #form select {
			-webkit-appearance: none;
			box-shadow: none;
			background-image: url(../images/arrow.png);
			background-position: right 10px center;
			background-repeat: no-repeat;
			cursor: pointer;
	}

	.form-wrapper #form textarea {
			height: 100px;
			resize: none;
	}

	.form-wrapper #form input[type="text"],
	.form-wrapper #form textarea {
			background-color: #efefef;
			color: #000;
			border: 0;
			box-shadow: none;
	}

	// .form-wrapper #form .checkbox input[type="checkbox"] {
	// 		margin-left: -40px;
	// 		display: none;
	// }

	// .form-wrapper #form .checkbox input[type="checkbox"]+label.check-icon {
	// 		position: absolute;
	// 		display: block;
	// 		width: 32px;
	// 		height: 32px;
	// 		background-image: url(../images/tick_box.png);
	// 		left: 0;
	// 		top: 0;
	// }

	// .form-wrapper #form .checkbox input[type="checkbox"]:checked+label.check-icon {
	// 		background-position: 0 -32px;
	// }

	// .form-wrapper #form .checkbox>label {
	// 		padding-left: 40px;
	// }

	.form-wrapper #form #submit {
			width: 125px;
			height: 35px;
			line-height: 35px;
			background-color: #000;
			color: #fff;
			text-decoration: none;
			text-align: center;
			display: block;
	}

	.form-wrapper #form label.error {
			color: red;
	}

	.form-wrapper #form label[for="privacy"].error {
			display: block;
			padding: 0;
			font-weight: bold;
	}
	.form-group {
		// overflow: hidden;
	}
	.p {
		// overflow: hidden;
    // float: left;
		// margin: 50px 0 0;
    font-size: 17px;	
    line-height: 25px;
    width: 100%;
	}

	//第五横，多选按钮
	.aui-checkbox {
		float: left;
		// display: inline-block;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		font-weight: 400;
		height: 44px;
		// line-height: 30px;
		// margin-top: 10px;
		margin-top: 0;
		padding-left: 50px;
		padding-right: 20px;
		margin-right: 16px;
		color: #000;
		box-shadow: 0 0 3px 3px rgba(255,255,255,0.2);
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
		-webkit-tap-highlight-color: rgba(255,255,255,0);
		transition: color, border;
		transition-duration: .25s;
		transition-timing-function: cubic-bezier(.75, .02, .5, 1);
		cursor: pointer;
		&:hover {
			.aui-checkbox__label {
				color: rgba(0, 0, 0, 1)
			}
			.aui-checkbox__box {
				border-color: rgba(0, 0, 0, .8);
			}
		}
		.aui-checkbox__label {
			font-size: 16px;
		}
		.aui-checkbox__input {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			position: absolute;
			width: 0;
			height: 0;
			overflow: hidden;
			margin: 0;
			padding: 0;
			border: 0;
			outline: 0;
			opacity: 0;
			z-index: -1;
			&:focus~.aui-checkbox__box {
				box-shadow: 0 0 3px 3px rgba(0, 0, 0, .1)
			}
		}
		.aui-checkbox__box {
			display: inline-block;
			overflow: hidden;
			position: absolute;
			top: 7px;
			left: 0;
			width: 30px;
			height: 30px;
			border: 1px solid rgba(0,0,0,.5);
			transition: box-shadow .15s linear,border .15s linear;
			cursor: pointer;
			pointer-events: none;
			z-index: 1;
			.aui-checkbox__tick {
				display: block;
				position: absolute;
				top: 50%;
				left: 50%;
				width: 20px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				color: rgba(0,0,0,.5);
				transform: translate(-50%,-50%);
				opacity: 0;
				transition: opacity .15s cubic-bezier(.75,.02,.5,1);
				pointer-events: none;
			}
			&.is-checked .aui-checkbox__tick {
				opacity: 1;
			}
		}
	}

	//隐私
	#privacy-fields {
		.aui-small {
			margin-bottom: 20px;
			font-size: 15px;
			line-height: 1.5;
		}
	}
	//隐私
	.check-text {
		overflow: hidden;
		margin: 0 0 35px;
		padding-bottom: 16px;
		// background: #e7e9ea;
    background: #f1f1f1;
		.check-p {
			overflow: hidden;
			padding-top: 5px;
			padding-bottom: 10px;
			.aui-checkbox {
				margin: 0;
				// height: auto;
				box-shadow: none;
				-webkit-box-shadow: none;
				.aui-checkbox__box {
					.aui-checkbox__tick {
						display: flex;
						flex-direction: column;
						justify-content: center;
						width: 100%;
						height: 100%;
						line-height: normal;
						color: #fff;
						background: #000;
					}
				}
				.aui-checkbox__label {
					font-size: 14px;
				}
			}
		}
	}

	.aui-button-group {
		float: right;
		margin-top: 0;
		display: -ms-inline-flexbox;
		display: inline-flex;
		-ms-flex-flow: row wrap;
		flex-flow: row wrap;
		-ms-flex-align: center;
		align-items: center;
		vertical-align: top;
		.aui-button {
			border-radius: 0;
			cursor: pointer;
			display: inline-block;
			position: relative;
			// padding: 16px 38px;
			outline: 0;
			font-family: inherit;
			font-size: 15px;
			font-weight: 400;
			// line-height: 1.5rem;
			text-align: center;
			text-decoration: none;
			white-space: normal;
			vertical-align: middle;
			width: 146px;
			height: 46px;
			transition: all .3s cubic-bezier(.75,.02,.5,1);
			-webkit-tap-highlight-color: transparent;
			-webkit-tap-highlight-color: rgba(255,255,255,0);
			-ms-flex: 1 1 auto;
			flex: 1 1 auto;
			margin: 0 10px 10px 0;
			border: 1px solid transparent;
			background: 0 0;
			.aui-button__text {
				display: inline-block;
				position: relative;
				text-align: left;
			}
		}
		
		.aui-button-primary {
			border-color: #000;
			background-color: #000;
			color: #fff;
			&:hover ,&:active, &.is-active {
				border-color: #333333;
				background-color: #333333;
				color: #fff;
			}
		}
	}
	//验证提示
	.textfield__counter {
		position: absolute;
		margin-top: 0;
		font-size: 12px;
		color: red;
		&.ys {
			bottom: -11px;
			margin-top: 0;
		}
		&.grey {
			color: #666;
		}
	}
	@media (max-width: 767px) {
		/*contact*/
		.g-recaptcha {
				transform: scale(0.9) !important;
				-webkit-transform: scale(0.9) !important;
				transform-origin: 0 0 !important;
				-webkit-transform-origin: 0 0 !important;
		}
		.form-wrapper #form #submit {
				float: none !important;
				margin: 30px auto 0;
		}
	}

  @media (max-width: 768px) {
		.p {
			font-size: 15px;
		}

		#contact h4,
		#contact p,
		#contact label {
				font-size: 15px;
		}

    #contact {
      form{
				.check-text {
					.check-p {
						padding-top: 7px;
						padding-bottom: 12px;
					}
				}
				.textfield__counter {
					&.ys {
						bottom: -14px;
					}
				}
			}
		}
		//隐私
		#privacy-fields {
			.aui-small {
				font-size: 13px;
			}
		}
  }
  @media (max-width: 606px) {
		//隐私
		.check-text {
			.check-p {
				.aui-checkbox {
					height: auto;
				}
			}
		}
  }
  @media (max-width: 468px) {
		.aui-checkbox {
			padding-right: 0;
		}
		#contact .iframe-map {
			width: 100%;
			height: 400px;
		}
    //第五横，按钮
    #contact {
      form{
				.check-text {
					.check-p {
						padding-top: 15px;
						padding-bottom: 15px;
					}
				}
				.textfield__counter {
					&.ys {
						bottom: -16px;
					}
				}
			}
		}
  }
</style>



// WEBPACK FOOTER //
// src/pages/ContactUs.vue